export default {
    required: '{attribute} es obligatorio.',
    integer: '{attribute} tiene que ser un número entero.',
    numeric: '{attribute} tiene que ser un número.',
    decimal: '{attribute} tiene que ser un número decimal.',
    minValue: '{attribute} tiene que ser mayor que {min}.',
    maxValue: '{attribute} tiene que ser menor que {max}.',
    between: 'Deber estar entre {min} y {max}.',
    email: '{attribute} formato de email invalido.',
    sameAs: '{attribute} tiene que ser igual que {eq}.',
    requiredUppercase: '{attribute} tiene que tener mayúsculas.',
    regex: '{attribute} formato invalido.',
}
